import script from "./CheckoutCustomerDeliverableSkeleton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckoutCustomerDeliverableSkeleton.vue?vue&type=script&lang=ts&setup=true"

import "./CheckoutCustomerDeliverableSkeleton.vue?vue&type=style&index=0&id=b749dc68&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b749dc68"]])

export default __exports__